<script>
import { conciliacaoClient } from '../../../libs'

export default {
  props: {
    operadoras: Array,
    prestadores: Array
  },
  data () {
    return {
      dialogOpen: false,
      dataMenu: false,
      pagamentoParams: {
        operadoraAnsId: '',
        prestadorId: '',
        dataPagamento: '',
        valorInformado: 0,
        valorPago: 0,
        valorGlosado: 0
      },
      isMissing: {
        operadoraAnsId: false,
        prestadorId: false,
        dataPagamento: false
      }
    }
  },
  methods: {
    handleDialogOpen () {
      this.dialogOpen = true
    },
    handleDialogClose () {
      this.dialogOpen = false
      this.pagamentoParams = {}
    },
    async criarPagamento() {
      this.isMissing.operadoraAnsId = !(this.pagamentoParams.operadoraAnsId)
      this.isMissing.prestadorId = !(this.pagamentoParams.prestadorId)
      this.isMissing.dataPagamento = !(this.pagamentoParams.dataPagamento)

      if (Object.values(this.isMissing).some(item => item)) return

      try {
        await conciliacaoClient.pagamento.createPagamento(this.pagamentoParams)
      } catch (error) {
        const modalParams = {
        type: 'error',
        title: 'Erro ao criar pagamento',
        btConfirm: {
          name: 'Ok',
          show: true,
          color: 'primary'
        }
      }

      this.$store.commit('confirmMessage/showConfirmMessage', modalParams)
      }
    },
    getErrorMessage(isMissing) {
      if (isMissing) return "Campo obrigatório"
      return null
    }
  },
  computed: {
    formattedDate () {
      const date = this.pagamentoParams.dataPagamento || ''

      if (!date) return null

      const [year, month, day] = date.split('-')
      return `${day}/${month}/${year}`
    }
  }
}
</script>

<template>
  <div>
    <v-tooltip right>
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          v-bind="attrs"
          v-on="on"
          @click="handleDialogOpen"
          icon
          color="primary"
        >
          <v-icon>fas fa-plus-circle</v-icon>
        </v-btn>
      </template>
      <span class="px-3 py-1 ma-0" style="border: solid 1px #999; border-radius: 5px; background-color: #FFF;">
        Cadastrar pagamento manualmente
      </span>
    </v-tooltip>
    <v-dialog
      v-model="dialogOpen"
      width="1000"
    >
      <v-card class="pa-6">
        <h2 class="mb-2">Criar registro de pagamento</h2>
        <v-row>
          <v-col cols="12" sm="4" class="px-3 py-0">
            <label>Prestador</label>
            <v-autocomplete
              v-model="pagamentoParams.prestadorId"
              :items="prestadores"
              :item-text="item => `${item.nome} (${item.id})`"
              item-value="id"
              label="Selecione"
              hide-no-data
              outlined
              flat
              solo
              dense
              filled
              clearable
              :error="isMissing.prestadorId"
              :error-messages="getErrorMessage(isMissing.prestadorId)"
              @click:clear="() => pagamentoParams.prestadorId = null"
            />
          </v-col>
          <v-col cols="12" sm="4" class="px-3 py-0">
            <label>Operadora</label>
            <v-autocomplete
              v-model="pagamentoParams.operadoraAnsId"
              :items="operadoras"
              :item-text="item => `${item.nome} (${item.id})`"
              item-value="id"
              label="Selecione"
              hide-no-data
              outlined
              flat
              solo
              dense
              filled
              clearable
              :error="isMissing.operadoraAnsId"
              :error-messages="getErrorMessage(isMissing.operadoraAnsId)"
              @click:clear="() => pagamentoParams.operadoraAnsId = null"
            />
          </v-col>
          <v-col cols="12" sm="4" class="px-3 py-0">
            <label>Data de pagamento</label>
            <v-menu
              ref="dataMenu"
              v-model="dataMenu"
              :close-on-content-click="false"
              transition="scale-transition"
              offset-y
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="formattedDate"
                  dense
                  readonly
                  label
                  outlined
                  v-bind="attrs"
                  v-on="on"
                  append-icon="mdi-calendar-blank"
                  clearable
                  :error="isMissing.dataPagamento"
                  :error-messages="getErrorMessage(isMissing.dataPagamento)"
                  @click:clear="() => pagamentoParams.dataPagamento = null"
                />
              </template>
              <v-date-picker
                no-title
                style="min-width: 100%"
                color="primary"
                v-model="pagamentoParams.dataPagamento"
                locale="pt-br"
              />
            </v-menu>
          </v-col>
          <v-col cols="12" sm="4" class="px-3 py-0">
            <label>Valor informado</label>
            <v-currency-field
              prefix="R$"
              dense
              label
              outlined
              :clearable="pagamentoParams.valorInformado > 0"
              v-model="pagamentoParams.valorInformado"
            />
          </v-col>
          <v-col cols="12" sm="4" class="px-3 py-0">
            <label>Valor pago</label>
            <v-currency-field
              prefix="R$"
              dense
              label
              outlined
              :clearable="pagamentoParams.valorPago > 0"
              v-model="pagamentoParams.valorPago"
            />
          </v-col>
          <v-col cols="12" sm="4" class="px-3 py-0">
            <label>Valor glosado</label>
            <v-currency-field
              prefix="R$"
              dense
              label
              outlined
              :clearable="pagamentoParams.valorGlosado > 0"
              v-model="pagamentoParams.valorGlosado"
            />
          </v-col>
        </v-row>
        <v-card-actions>
          <v-btn color="primary" outlined @click="handleDialogClose">Cancelar</v-btn>
          <v-btn color="primary" @click="criarPagamento">Criar pagamento</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<style scoped>
button.v-expansion-panel-header {
  background-color: #d1dcea;
  border-radius: 2px;
  padding: 0;
}
.v-expansion-panel::before {
  box-shadow: none;
}
.v-expansion-panel::after {
  display: none;
}
.v-expansion-panel-content {
  display: flex;
  margin: 0 -24px;
}
.tooltip-box {
  border: solid 1px #999;
  border-radius: 5px;
  background-color: #fff;
  padding: 1 3;
  margin: 0;
}
.theme--light.v-data-table.pgtosLotesListTable
  > .v-data-table__wrapper
  > table
  > thead
  > tr
  > th:first-child,
.theme--light.v-data-table.pgtosLotesListTable
  > .v-data-table__wrapper
  > table
  > tbody
  > tr
  > td:first-child {
  max-width: 150px;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}
.check-header-rec2 {
  position: absolute;
  margin-top: 10px;
  margin-left: -4px;
}
.no-box-shadow {
  box-shadow: 0 0 0 0 !important;
  padding-block: 12px;
}
.content-wrapper {
  padding-block: 0;
  display: flex;
  flex-direction: column;
  justify-content: space-evenly;
  line-height: 1;
}
.icon-wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  padding-left: 8px;
}
.v-expansion-panel-header .row {
  align-items: center;
}
.content-background {
  background-color: #eff3f8;
  margin: 0;
}
.percent-wrapper {
  display: flex;
  align-items: center;
}
.menu-wrapper {
  display: flex;
  justify-content: space-around;
  padding-left: 24px;
}
</style>
